import { Link } from 'react-router-dom';

const LEGAL_LINKS = [
  { to: '/legal/terms',          label: 'Terms' },
  { to: '/legal/privacy',        label: 'Privacy' },
  { to: '/legal/cookies',        label: 'Cookies' },
  { to: '/legal/acceptable-use', label: 'Acceptable Use' },
  { to: '/legal/dmca',           label: 'DMCA' },
  { to: '/legal/refunds',        label: 'Refunds' },
];

export default function Footer({ onCookiePreferences }) {
  return (
    <footer style={{
      borderTop: '0.5px solid var(--border)',
      background: 'var(--surface)',
      padding: '20px 24px',
      fontFamily: 'var(--font)',
    }}>
      <div style={{
        maxWidth: 1080, margin: '0 auto',
        display: 'flex', flexDirection: 'column', gap: 12,
        alignItems: 'center',
      }}>
        {/* Legal links */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 18px', justifyContent: 'center' }}>
          {LEGAL_LINKS.map(l => (
            <Link key={l.to} to={l.to} style={{ fontSize: 12, color: 'var(--dim)', textDecoration: 'none' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--muted)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--dim)'}>
              {l.label}
            </Link>
          ))}
          {onCookiePreferences && (
            <button onClick={onCookiePreferences} style={{
              fontSize: 12, color: 'var(--dim)', background: 'none',
              border: 'none', padding: 0, cursor: 'pointer', fontFamily: 'var(--font)',
            }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--muted)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--dim)'}>
              Cookie Preferences
            </button>
          )}
        </div>

        {/* Copyright */}
        <div style={{ fontSize: 11, color: 'var(--dim)' }}>
          © {new Date().getFullYear()} CopyPasteGenius · All rights reserved ·{' '}
          <a href="mailto:legal@copypastegenius.com" style={{ color: 'var(--dim)', textDecoration: 'none' }}>
            legal@copypastegenius.com
          </a>
        </div>
      </div>
    </footer>
  );
}